
export const FingerPrint =() => {
    return(
        <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 512 512"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <path
        fill="#B9BBC1"
        d="M192 92c-13.531 0-25.664 8.574-30.172 21.332a7.994 7.994 0 004.875 10.211c2.733.982 5.594.241 7.695-1.501L208 162.393V172c0 4.418 3.578 8 8 8s8-3.582 8-8v-48c0-17.645-14.352-32-32-32z"
      ></path>
      <path
        fill="#8B8996"
        d="M168 108c-14.664 0-28.523 5.629-39.328 16.176L26.102 236.152l11.797 10.805 2.771-3.027L208 289.806V292c0 4.418 3.578 8 8 8s8-3.582 8-8V164c0-30.879-25.125-56-56-56z"
      ></path>
      <path
        fill="#B9BBC1"
        d="M320 92c13.531 0 25.664 8.574 30.172 21.332a7.994 7.994 0 01-4.875 10.211c-2.733.982-5.594.241-7.695-1.501L304 162.393V172c0 4.418-3.578 8-8 8s-8-3.582-8-8v-48c0-17.645 14.351-32 32-32z"
      ></path>
      <path
        fill="#8B8996"
        d="M344 108c14.664 0 28.523 5.629 39.328 16.176l102.57 111.977-11.797 10.805-2.771-3.027L304 289.806V292c0 4.418-3.578 8-8 8s-8-3.582-8-8V164c0-30.879 25.125-56 56-56z"
      ></path>
      <circle cx="112" cy="308" r="88" fill="#53DCFF"></circle>
      <path
        fill="#5C546A"
        d="M112 196C50.242 196 0 246.242 0 308s50.242 112 112 112 112-50.242 112-112-50.242-112-112-112zm0 192c-44.111 0-80-35.889-80-80s35.889-80 80-80 80 35.889 80 80-35.889 80-80 80z"
      ></path>
      <path
        fill="#5C546A"
        d="M192 204h128l1.23-.017C305.661 219.23 296 240.487 296 264v28h-80v-28c0-23.513-9.661-44.77-25.23-60.017"
      ></path>
      <circle cx="128" cy="292" r="32" fill="#FFF"></circle>
      <circle cx="400" cy="308" r="88" fill="#53DCFF"></circle>
      <path
        fill="#5C546A"
        d="M400 196c-61.758 0-112 50.242-112 112s50.242 112 112 112 112-50.242 112-112-50.242-112-112-112zm0 192c-44.111 0-80-35.889-80-80s35.889-80 80-80 80 35.889 80 80-35.889 80-80 80z"
      ></path>
      <circle cx="416" cy="292" r="32" fill="#FFF"></circle>
      <path fill="#8B8996" d="M192 188H320V204H192z"></path>
    </svg>
    )
}



export const Distribution =() => {
    return (
        <svg
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#ecf2ff"
        d="M173.379 358.338L66.68 312.605c-7.617-3.267-11.147-12.085-7.881-19.688 3.252-7.646 12.144-11.177 19.688-7.881l106.699 45.732c7.617 3.267 11.147 12.085 7.881 19.688-3.297 7.726-12.244 11.121-19.688 7.882zM58.799 461.082c-3.267-7.603.264-16.421 7.881-19.688l106.699-45.732c7.559-3.296 16.421.249 19.688 7.881 3.267 7.603-.264 16.421-7.881 19.688l-106.7 45.732c-7.441 3.238-16.389-.152-19.687-7.881z"
      ></path>
      <path
        fill="#d9e5ff"
        d="M433.514 468.963l-108.7-45.733c-7.617-3.267-11.147-12.085-7.881-19.688 3.267-7.632 12.158-11.147 19.688-7.881l108.699 45.732c7.617 3.267 11.147 12.085 7.881 19.688-3.296 7.726-12.243 11.121-19.687 7.882zM330.718 359.554c-5.815 0-11.353-3.398-13.784-9.097-3.267-7.603.264-16.421 7.881-19.688l108.699-45.732c7.515-3.325 16.421.234 19.688 7.881 3.267 7.603-.264 16.421-7.881 19.688l-108.699 45.732a14.757 14.757 0 01-5.904 1.216z"
      ></path>
      <g>
        <path
          fill="#a0e65c"
          d="M255 452c-58.872 0-105-32.944-105-75 0-32.08 27.026-59.795 68.833-70.62 6.548-1.743 13.374 1.157 16.758 7.017L255 347.015l19.409-33.618c3.369-5.83 10.195-8.672 16.758-7.017C332.974 317.205 360 344.92 360 377c0 42.056-46.128 75-105 75z"
        ></path>
        <path
          fill="#79cc52"
          d="M360 377c0-32.08-27.026-59.795-68.833-70.62-6.562-1.655-13.389 1.187-16.758 7.017L255 347.015V452c58.872 0 105-32.944 105-75z"
        ></path>
        <path
          fill="#ff6759"
          d="M255 0c-74.399 0-135 60.599-135 135 0 60.472 32.932 86.061 122.1 249.5 2.699 4.499 7.5 7.5 12.9 7.5s10.201-3.001 12.9-7.5C357.1 221.003 390 195.486 390 135 390 60.599 329.399 0 255 0zm0 210c-41.4 0-75-33.6-75-75s33.6-75 75-75 75 33.6 75 75-33.6 75-75 75z"
        ></path>
        <path
          fill="#e63a3a"
          d="M330 135c0 41.4-33.6 75-75 75v182c5.4 0 10.201-3.001 12.9-7.5C357.1 221.001 390 195.485 390 135 390 60.599 329.399 0 255 0v60c41.4 0 75 33.6 75 75z"
        ></path>
        <path
          fill="#ffdf40"
          d="M45 512c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45z"
        ></path>
        <path
          fill="#ffbe40"
          d="M467 512c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45z"
        ></path>
        <path
          fill="#ffdf40"
          d="M45 332c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45z"
        ></path>
        <path
          fill="#ffbe40"
          d="M467 332c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45z"
        ></path>
      </g>
    </svg>
    )
}



export const Forest =() => {
    return (
        <svg
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#0a5b36"
        d="M251.346 449.356a7.508 7.508 0 01-7.508-7.508V372.25c0-4.147 3.361-7.508 7.508-7.508s7.508 3.361 7.508 7.508v69.598a7.508 7.508 0 01-7.508 7.508zM329.118 452.264a7.507 7.507 0 01-7.508-7.508V336.06c0-4.147 3.361-7.508 7.508-7.508s7.508 3.361 7.508 7.508v108.695a7.509 7.509 0 01-7.508 7.509z"
      ></path>
      <circle cx="246.069" cy="317.045" r="67.218" fill="#0f7a4f"></circle>
      <path
        fill="#0c6842"
        d="M313.288 317.048c0 37.119-30.099 67.218-67.218 67.218a66.92 66.92 0 01-41.889-14.65 67.062 67.062 0 0019.019 2.73c37.119 0 67.208-30.099 67.208-67.218 0-21.28-9.89-40.259-25.319-52.568 27.86 8.2 48.199 33.969 48.199 64.488z"
      ></path>
      <circle cx="349.753" cy="156.451" r="67.218" fill="#158f5e"></circle>
      <path
        fill="#0f7a4f"
        d="M416.975 156.453c0 37.119-30.099 67.218-67.218 67.218-5.37 0-10.59-.63-15.589-1.82 29.599-7.04 51.618-33.649 51.618-65.398 0-31.759-22.019-58.368-51.618-65.398 5-1.19 10.22-1.82 15.589-1.82 37.119 0 67.218 30.089 67.218 67.218z"
      ></path>
      <circle cx="437.805" cy="248.006" r="67.218" fill="#158f5e"></circle>
      <path
        fill="#0f7a4f"
        d="M505.022 248.01c0 37.119-30.099 67.218-67.218 67.218-6.11 0-12.03-.82-17.659-2.35 32.939-4.34 58.358-32.519 58.358-66.638 0-31.009-20.999-57.118-49.558-64.868 2.9-.38 5.86-.58 8.86-.58 37.118 0 67.217 30.089 67.217 67.218zM360.518 449.356a7.507 7.507 0 01-7.508-7.508V341.599c0-4.147 3.361-7.508 7.508-7.508s7.508 3.361 7.508 7.508v100.249a7.507 7.507 0 01-7.508 7.508z"
      ></path>
      <path
        fill="#d2f0a2"
        d="M394.659 367.423c-28.979 0-52.471-23.492-52.471-52.471V200.193c0-28.979 23.492-52.471 52.471-52.471 28.979 0 52.471 23.492 52.471 52.471v114.758c0 28.98-23.492 52.472-52.471 52.472z"
      ></path>
      <path
        fill="#bcea73"
        d="M447.134 200.191v114.756c0 28.979-23.499 52.478-52.478 52.478-4.45 0-8.77-.55-12.89-1.6 22.749-5.74 39.589-26.349 39.589-50.878V200.191c0-14.49-5.87-27.609-15.37-37.099a52.362 52.362 0 00-24.219-13.77 52.14 52.14 0 0112.89-1.6c14.49 0 27.609 5.87 37.109 15.37 9.499 9.49 15.369 22.61 15.369 37.099z"
      ></path>
      <path
        fill="#a3e440"
        d="M416.595 290.18a7.51 7.51 0 00-10.618 0l-3.81 3.81v-16.401V248.233c0-4.147-3.361-7.508-7.508-7.508s-7.508 3.361-7.508 7.508v11.227l-7.571-7.572a7.507 7.507 0 00-10.617-.001 7.506 7.506 0 00-.001 10.617l18.19 18.191v157.082c0 4.147 3.361 7.508 7.508 7.508s7.508-3.361 7.508-7.508V315.226l14.428-14.428a7.51 7.51 0 00-.001-10.618z"
      ></path>
      <g>
        <path
          fill="#d2f0a2"
          d="M127.393 236.129c-28.979 0-52.471-23.492-52.471-52.471v-73.452c0-28.979 23.492-52.471 52.471-52.471 28.979 0 52.471 23.492 52.471 52.471v73.452c.001 28.979-23.492 52.471-52.471 52.471z"
        ></path>
        <path
          fill="#bcea73"
          d="M179.863 110.204v73.458c0 28.979-23.489 52.469-52.468 52.469-4.96 0-9.77-.69-14.32-1.98 22.019-6.23 38.149-26.469 38.149-50.488v-73.458c0-14.49-5.87-27.609-15.369-37.099a52.322 52.322 0 00-22.779-13.389c4.55-1.29 9.36-1.98 14.32-1.98 14.49 0 27.609 5.87 37.099 15.369 9.498 9.489 15.368 22.609 15.368 37.098z"
        ></path>
        <path
          fill="#a3e440"
          d="M149.329 158.886a7.509 7.509 0 00-10.617 0l-3.811 3.811v-16.402-29.355c0-4.147-3.361-7.508-7.508-7.508s-7.508 3.361-7.508 7.508v11.227l-7.572-7.573a7.509 7.509 0 00-10.617 10.618l18.19 18.19v295.354c0 4.147 3.361 7.508 7.508 7.508s7.508-3.361 7.508-7.508V183.933l14.428-14.428a7.51 7.51 0 00-.001-10.619z"
        ></path>
      </g>
      <g>
        <circle cx="200.949" cy="253.095" r="79.666" fill="#1ca56f"></circle>
        <path
          fill="#158f5e"
          d="M280.619 253.09c0 43.999-35.669 79.667-79.667 79.667-12.63 0-24.569-2.94-35.179-8.18 37.049-6.84 65.118-39.309 65.118-78.337 0-31.369-18.129-58.498-44.479-71.488 4.71-.87 9.57-1.32 14.54-1.32 43.998 0 79.667 35.669 79.667 79.658z"
        ></path>
        <path
          fill="#0f7a4f"
          d="M224.279 216.655a7.507 7.507 0 00-10.617.001l-5.205 5.204v-8.667c0-4.147-3.361-7.508-7.508-7.508s-7.508 3.361-7.508 7.508v79.458c0 4.147 3.361 7.508 7.508 7.508s7.508-3.361 7.508-7.508v-49.557l15.822-15.823a7.506 7.506 0 000-10.616zM200.949 452.264a7.508 7.508 0 01-7.508-7.508v-71.292c0-4.147 3.361-7.508 7.508-7.508s7.508 3.361 7.508 7.508v71.292a7.507 7.507 0 01-7.508 7.508z"
        ></path>
      </g>
      <g>
        <path
          fill="#a3e440"
          d="M349.753 270.126c0 92.327-23.688 90.68-52.909 90.68s-52.909 1.647-52.909-90.68 29.857-196.494 52.909-196.494 52.909 104.167 52.909 196.494z"
        ></path>
        <path
          fill="#a3e440"
          d="M349.753 270.126c0 92.327-23.688 90.68-52.909 90.68s-52.909 1.647-52.909-90.68 29.857-196.494 52.909-196.494 52.909 104.167 52.909 196.494z"
        ></path>
        <path
          fill="#99d53b"
          d="M349.748 270.124c0 92.332-23.682 90.681-52.904 90.681-4.759 0-9.381.046-13.774-.287 22.535-1.675 39.13-13.132 39.13-90.394 0-74.591-19.496-156.899-39.13-185.777 4.668-6.87 9.347-10.712 13.774-10.712 23.051.001 52.904 104.169 52.904 196.489z"
        ></path>
        <path
          fill="#88ba31"
          d="M328.708 279.854a7.51 7.51 0 00-10.618 0l-13.738 13.738v-28.744-33.826c0-4.147-3.361-7.508-7.508-7.508s-7.508 3.361-7.508 7.508v15.695l-10.678-10.678a7.508 7.508 0 00-10.618 10.618l21.296 21.296V441.848c0 4.147 3.361 7.508 7.508 7.508s7.508-3.361 7.508-7.508v-127.02l24.356-24.356a7.508 7.508 0 000-10.618z"
        ></path>
      </g>
      <g>
        <path
          fill="#a3e440"
          d="M8.038 337.498c0 71.114 32.054 69.845 71.594 69.845s71.594 1.269 71.594-69.845-40.401-151.346-71.594-151.346S8.038 266.384 8.038 337.498z"
        ></path>
        <path
          fill="#99d53b"
          d="M8.038 337.498c0 71.114 32.054 69.845 71.594 69.845s71.594 1.269 71.594-69.845-40.401-151.346-71.594-151.346S8.038 266.384 8.038 337.498z"
        ></path>
        <path
          fill="#8dc637"
          d="M151.223 337.497c0 71.118-32.049 69.848-71.588 69.848-5.14 0-10.14.02-14.969-.1 32.349-.79 56.618-7.87 56.618-69.748 0-60.098-28.849-126.706-56.618-145.895 5.09-3.53 10.14-5.45 14.969-5.45 31.19 0 71.588 80.228 71.588 151.345z"
        ></path>
      </g>
      <g>
        <path
          fill="#a3e440"
          d="M219.496 340.171c0 52.554-23.688 51.616-52.909 51.616s-52.909.938-52.909-51.616 29.857-111.846 52.909-111.846 52.909 59.292 52.909 111.846z"
        ></path>
        <path
          fill="#a3e440"
          d="M219.496 340.171c0 52.554-23.688 51.616-52.909 51.616s-52.909.938-52.909-51.616 29.857-111.846 52.909-111.846 52.909 59.292 52.909 111.846z"
        ></path>
        <path
          fill="#99d53b"
          d="M219.491 340.167c0 52.558-23.679 51.618-52.908 51.618-5.45 0-10.7.03-15.649-.26 21.579-1.25 37.259-8.6 37.259-51.358 0-41.109-18.269-86.337-37.259-104.097 5.28-4.94 10.63-7.75 15.649-7.75 23.059.001 52.908 59.299 52.908 111.847z"
        ></path>
        <path
          fill="#88ba31"
          d="M198.451 326.323a7.509 7.509 0 00-10.617 0l-13.739 13.739v-36.756c0-4.147-3.361-7.508-7.508-7.508s-7.508 3.361-7.508 7.508v138.543c0 4.147 3.361 7.508 7.508 7.508s7.508-3.361 7.508-7.508v-80.552l24.356-24.356a7.508 7.508 0 000-10.618z"
        ></path>
      </g>
      <g>
        <path
          fill="#a3e440"
          d="M501.49 365.772c0 37.876-17.072 37.201-38.132 37.201s-38.132.676-38.132-37.201 21.518-80.609 38.132-80.609 38.132 42.733 38.132 80.609z"
        ></path>
        <path
          fill="#a3e440"
          d="M501.49 365.772c0 37.876-17.072 37.201-38.132 37.201s-38.132.676-38.132-37.201 21.518-80.609 38.132-80.609 38.132 42.733 38.132 80.609z"
        ></path>
        <path
          fill="#99d53b"
          d="M501.492 365.776c0 37.869-17.079 37.199-38.139 37.199-4.48 0-8.78.03-12.77-.29 14.78-1.17 25.349-7.1 25.349-36.909 0-28.549-12.22-59.848-25.349-73.548 4.28-4.48 8.67-7.07 12.77-7.07 16.62.001 38.139 42.739 38.139 80.618z"
        ></path>
        <path
          fill="#88ba31"
          d="M483.198 358.915a7.507 7.507 0 00-10.617.001l-1.715 1.715v-21.427c0-4.147-3.361-7.508-7.508-7.508s-7.508 3.361-7.508 7.508V441.85c0 4.147 3.361 7.508 7.508 7.508s7.508-3.361 7.508-7.508v-59.982l12.333-12.334a7.51 7.51 0 00-.001-10.619z"
        ></path>
      </g>
      <path
        fill="#88ba31"
        d="M98.668 309.904a7.508 7.508 0 00-10.617-10.618l-.911.911v-20.668c0-4.147-3.361-7.508-7.508-7.508s-7.508 3.361-7.508 7.508v64.223l-9.453-9.453a7.509 7.509 0 00-10.617 10.618l20.071 20.07v76.862c0 4.147 3.361 7.508 7.508 7.508s7.508-3.361 7.508-7.508v-79.97-40.447z"
      ></path>
      <g>
        <path
          fill="#0a5b36"
          d="M504.492 454.266H7.508a7.508 7.508 0 010-15.016h496.984c4.147 0 7.508 3.361 7.508 7.508s-3.361 7.508-7.508 7.508z"
        ></path>
      </g>
    </svg>
    )
}



export const Feeding = () => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="512"
        height="512"
        viewBox="0 0 60 60"
      >
        <path
          fill="#285680"
          d="M39.4 51.978c6.873.6 11.6 1.851 11.6 3.307C51 57.34 41.633 59 30.091 59S9.182 57.34 9.182 55.285c0-1.443 4.711-2.708 11.583-3.307zM11.97 46.39C7.575 46.39 4 43.5 4 39.95c0-3.1 2.725-5.764 6.479-6.338a.942.942 0 01.151-.012v1.033l.146.955C8.011 36.013 6 37.847 6 39.95c0 2.448 2.678 4.44 5.97 4.44a6.541 6.541 0 003.641-.99l1.08 1.683a8.585 8.585 0 01-4.721 1.307z"
        ></path>
        <path fill="#f29c1f" d="M33 15.669h2V30h-2zM37 16.08h2V30h-2z"></path>
        <path
          fill="#2980ba"
          d="M49.61 32.8a2.771 2.771 0 00-2.79-2.72 2.844 2.844 0 00-1.51.44 4.164 4.164 0 00-4.07-3.16 4.213 4.213 0 00-3.2 1.48 4.922 4.922 0 00-8.92 0 4.212 4.212 0 00-6-.42 4.205 4.205 0 00-6.58 1.32 3.523 3.523 0 00-2.48-1.02 3.447 3.447 0 00-3.48 3.4 3.288 3.288 0 00.15 1.01v.01l-.14.04a.06.06 0 01-.01-.04c0 10.52 8.74 21.78 19.51 21.78 10.68 0 19.36-11.06 19.5-21.5a1.23 1.23 0 00.02-.28l-.02-.06a1.23 1.23 0 00.02-.28z"
        ></path>
        <path
          fill="#67b9cc"
          d="M49.59 33.08l.02.06c0 .69-1.83 1.32-4.85 1.8-.35.06-.72.11-1.09.15h-.02a.01.01 0 00-.01.01c-1.21.17-2.58.3-4.07.43-1.62.12-3.39.21-5.26.27h-.04c-.01 0-.04.01-.05.01-.35 0-.73.02-1.09.03h-.07c-.98.01-1.97.03-2.97.03-1.21 0-2.4-.02-3.54-.04h-.08c-.46-.02-.92-.03-1.37-.05-.01 0-.04-.01-.06-.01-1.12-.04-2.21-.09-3.24-.16h-.02a76.54 76.54 0 01-3.52-.3.02.02 0 00-.02-.02c-4.04-.42-6.83-1.07-7.51-1.81v-.01a.438.438 0 01-.14-.29l.14-.04v-.01a3.288 3.288 0 01-.15-1.01 3.447 3.447 0 013.48-3.4 3.523 3.523 0 012.48 1.02 4.205 4.205 0 016.58-1.32 4.212 4.212 0 016 .42 4.922 4.922 0 018.92 0 4.213 4.213 0 013.2-1.48 4.164 4.164 0 014.07 3.16 2.844 2.844 0 011.51-.44 2.771 2.771 0 012.79 2.72 1.23 1.23 0 01-.02.28z"
        ></path>
        <path
          fill="#a56a43"
          d="M26.39 4.641a5.543 5.543 0 011.66-1.81 7.873 7.873 0 015.4-1.82 8.1 8.1 0 016.66 4.64 20.238 20.238 0 001.4 2.65l2.3 1.93a1.067 1.067 0 00.19.09A7.041 7.041 0 0047 11a8.339 8.339 0 001 0c-.01 0 .12.35-.92 2.22A12.083 12.083 0 0144 16.941a11.365 11.365 0 01-7.84 2.29A16.181 16.181 0 0134.09 19a10.755 10.755 0 01-8.78-7.84 9.1 9.1 0 01-.24-1.66c-.01-.17-.01-.35-.01-.52z"
        ></path>
        <path
          fill="#e64c3c"
          d="M25.31 11.161A10.755 10.755 0 0034.09 19a16.181 16.181 0 002.07.23 5.321 5.321 0 00.09-1.05 3.71 3.71 0 00-.06-.67c-.42-2.04-2.45-3.78-4.06-4.93A7.648 7.648 0 0026 11z"
        ></path>
        <path fill="#f29c1f" d="M26.386 4.637S28 8 25 9l-4-3z"></path>
        <path
          fill="#ecf0f1"
          d="M29 6a2 2 0 004 0 1.871 1.871 0 00-.09-.59 2.024 2.024 0 00-1.32-1.32A1.871 1.871 0 0031 4a2.006 2.006 0 00-2 2z"
        ></path>
        <circle cx="31" cy="6.001" r="1" fill="#35495e"></circle>
        <path
          fill="#cb8252"
          d="M37 8c1.874 1.25 4.137.548 5.573-.154a1 1 0 011.435.971c-.131 1.8-.729 4.442-3.008 5.636a5.7 5.7 0 01-3.481-2.008C36.519 11.144 37 8 37 8z"
        ></path>
        <path
          fill="#805333"
          d="M51 6.39a5.148 5.148 0 012.854 3.35 1.011 1.011 0 01-.971 1.26H48l1.633-4.082A1 1 0 0151 6.39z"
        ></path>
        <path
          fill="#fff"
          d="M31 5a1 1 0 001.91.41 2.024 2.024 0 00-1.32-1.32A1 1 0 0031 5z"
        ></path>
        <path
          fill="#285680"
          d="M30.091 51.919a1 1 0 110-2c3.732 0 7.369-1.94 10.24-5.464a1 1 0 011.551 1.264c-3.259 3.998-7.446 6.2-11.791 6.2z"
        ></path>
      </svg>
    )
}



export const Breeding =() => {
    return (
        <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 512.001 512.001"
      version="1.1"
      viewBox="0 0 512.001 512.001"
      xmlSpace="preserve"
    >
      <path
        fill="#D7D7E6"
        d="M436.841 271.403c27.095-80.033 3.344-179.159-60.082-200.631s-142.508 42.842-169.602 122.873 8.059 145.477 71.484 166.949c63.426 21.472 131.105-9.158 158.2-89.191z"
      ></path>
      <path
        fill="#F0F0FA"
        d="M317.772 234.73c0-84.494-54.283-170.771-121.244-170.771S75.284 150.235 75.284 234.73s54.283 135.21 121.244 135.21 121.244-50.716 121.244-135.21z"
      ></path>
      <path
        fill="#F5C86E"
        d="M410.901 370.762H101.099c-35.323 0-63.959-28.636-63.959-63.959v-79.949h437.72v79.949c0 35.324-28.636 63.959-63.959 63.959z"
      ></path>
      <path
        fill="#C88C64"
        d="M416.897 447.713L501.842 447.713 501.842 387.738 354.937 370.748 447.877 310.454 396.91 293.145 278.616 370.561 277.986 370.762 10.157 370.762 10.157 447.713 436.97 447.713z"
      ></path>
      <g fill="#A5DC69">
        <path d="M211.836 352.347c-23.419-22.982-18.231-66.078-18.198-66.429l-.007-.007.005.005-.009-.009.006.006c.183-.017 41.676-4.099 65.146 18.923 23.457 23.021 19.231 65.24 19.199 65.422l.012.012c0 .001-42.641 5.156-66.154-17.923zM359.537 484.101c-22.763-22.34-17.722-64.23-17.69-64.571l-.007-.007.005.005-.009-.009.006.006c.178-.016 40.51-3.984 63.323 18.393 22.8 22.377 18.693 63.414 18.662 63.592l.011.011c.001.002-41.447 5.013-64.301-17.42z"></path>
        <path d="M290.073 328.254c14.701-14.979 42.266-11.662 42.49-11.641l.004-.004-.004.004.006-.006-.004.004c.011.117 2.622 26.657-12.103 41.669-14.725 15.003-41.729 12.301-41.846 12.28l-.008.008s-3.297-27.275 11.465-42.314z"></path>
      </g>
      <path d="M10.157 380.756h267.828c.529 0 4.215-.009 5.986-.009 10.505 0 30.391-1.984 43.624-15.469 6.688-6.818 10.475-15.244 12.598-23.221.122-.072.249-.126.369-.204l61.809-40.34c4.622-3.017 5.923-9.209 2.907-13.831-3.016-4.621-9.209-5.922-13.83-2.906l-48.852 31.884c-.02-.275-.039-.523-.055-.709a9.96 9.96 0 00-2.906-6.41 9.944 9.944 0 00-6.311-2.897c-4.608-.472-33.449-2.645-50.383 14.609-.47.479-.917.971-1.358 1.467-3.375-8.945-8.385-17.736-15.805-25.017-25.482-24.996-67.995-22.167-72.736-21.769a9.97 9.97 0 00-6.153 2.602 9.956 9.956 0 00-3.218 6.591c-.646 6.104-4.211 49.449 21.165 74.353v-.001c.45.442.909.865 1.369 1.289H101.099c-29.757 0-53.965-24.21-53.965-53.965v-69.955h399.452l.018.001.021-.001h18.242v69.955c0 29.756-24.208 53.965-53.965 53.965h-22.221l64.636-41.931c4.63-3.004 5.949-9.193 2.945-13.823s-9.192-5.947-13.823-2.945l-92.94 60.294a9.992 9.992 0 004.29 18.311l146.906 16.989c.391.045.777.067 1.161.067 5.005 0 9.326-3.754 9.915-8.847.635-5.482-3.296-10.44-8.779-11.075l-56.023-6.479c22.584-12.673 37.887-36.84 37.887-64.528v-79.949c0-5.518-4.474-9.994-9.994-9.994h-17.42c1.952-32.392-2.991-64.365-14.245-91.082-13.843-32.862-35.707-55.156-63.229-64.474-33.716-11.414-73.227-1.813-109.563 26.322-21.952-21.873-47.516-33.66-73.876-33.66-33.919 0-66.52 19.507-91.799 54.926-21.53 30.168-35.38 69.048-38.67 107.97H37.14c-5.519 0-9.994 4.475-9.994 9.994v79.949c0 21.271 9.04 40.461 23.465 53.965H10.157c-5.519 0-9.994 4.475-9.994 9.994s4.475 9.994 9.994 9.994zm287.047-45.502c6.616-6.741 17.636-8.527 25.38-8.878-.619 7.95-2.892 18.417-9.255 24.905-6.371 6.492-16.956 8.758-24.972 9.344.424-8.126 2.478-18.88 8.847-25.371zm-94.074-39.609c12.196.214 34.68 2.62 48.65 16.325 14.029 13.768 16.364 36.534 16.517 48.787-12.402.073-35.484-1.822-49.461-15.541l-.001-.001c-13.952-13.693-15.818-37.008-15.705-49.57zM373.556 80.238c27.729 9.388 43.158 34.167 51.218 53.302 10.22 24.262 14.614 53.55 12.641 83.322H326.997c-3.29-38.922-17.139-77.801-38.67-107.97a181.06 181.06 0 00-4.66-6.24c30.62-23.349 62.968-31.527 89.889-22.414zm-252.559 40.264c21.423-30.018 48.248-46.549 75.531-46.549 23.061 0 45.793 11.812 65.214 33.595.053.065.097.133.152.197.083.097.174.182.26.274a153.784 153.784 0 019.905 12.482c19.191 26.89 31.653 61.513 34.885 96.359H86.113c3.232-34.846 15.694-69.469 34.884-96.358z"></path>
      <path d="M152.731 114.183c-5.435 5.135-10.638 11.168-15.464 17.93-10.539 14.768-19.028 32.556-24.546 51.444-1.548 5.298 1.492 10.847 6.79 12.395.936.273 1.879.404 2.807.404 4.326 0 8.314-2.832 9.588-7.193 4.897-16.76 12.377-32.473 21.63-45.438 4.077-5.713 8.425-10.764 12.922-15.013 4.012-3.791 4.191-10.116.401-14.128-3.79-4.01-10.114-4.192-14.128-.401zM196.528 93.94c-.368 0-.737.005-1.105.014-5.517.13-9.886 4.708-9.756 10.225.128 5.438 4.576 9.759 9.987 9.759l.24-.003c.212-.005.424-.008.636-.008 5.519 0 9.994-4.475 9.994-9.994s-4.477-9.993-9.996-9.993zM68.216 278.558c-3.903 3.902-3.903 10.23 0 14.134l15.169 15.169a9.965 9.965 0 007.066 2.927 9.961 9.961 0 007.066-2.927c3.902-3.902 3.902-10.23 0-14.134l-15.169-15.169c-3.901-3.902-10.228-3.902-14.132 0zM131.175 263.593l-10.16 10.16c-3.902 3.902-3.902 10.23 0 14.134a9.965 9.965 0 007.066 2.927 9.961 9.961 0 007.066-2.927l10.16-10.16c3.902-3.902 3.902-10.23 0-14.134-3.902-3.902-10.23-3.902-14.132 0zM298.456 258.431c-3.902 3.902-3.902 10.229 0 14.133l5.303 5.303a9.965 9.965 0 007.066 2.927 9.958 9.958 0 007.066-2.928c3.902-3.902 3.902-10.229 0-14.133l-5.303-5.303c-3.902-3.904-10.23-3.903-14.132.001zM375.679 257.257l-3.825 3.824c-3.902 3.902-3.904 10.229 0 14.133a9.962 9.962 0 007.066 2.928 9.963 9.963 0 007.066-2.927l3.825-3.824c3.902-3.901 3.904-10.229 0-14.133-3.901-3.903-10.229-3.902-14.132-.001zM442.464 291.228a9.958 9.958 0 007.066-2.928c3.902-3.902 3.902-10.229 0-14.133l-5.495-5.494c-3.902-3.901-10.23-3.902-14.133.001-3.902 3.902-3.902 10.229 0 14.133l5.495 5.494a9.969 9.969 0 007.067 2.927zM256.043 38.843c5.519 0 9.994-4.475 9.994-9.994V9.994c0-5.518-4.474-9.994-9.994-9.994s-9.994 4.475-9.994 9.994V28.85c0 5.519 4.474 9.993 9.994 9.993zM218.928 44.046a9.96 9.96 0 007.063 2.924 9.956 9.956 0 007.069-2.931c3.902-3.904 3.898-10.231-.006-14.133l-8.13-8.122a9.99 9.99 0 00-14.133.007c-3.902 3.904-3.897 10.231.006 14.133l8.131 8.122zM286.226 46.874a9.96 9.96 0 007.07-2.931l8.067-8.075c3.901-3.904 3.897-10.232-.007-14.133-3.905-3.903-10.232-3.899-14.133.007l-8.067 8.075c-3.901 3.905-3.897 10.232.007 14.133a9.953 9.953 0 007.063 2.924zM501.842 437.72h-83.643a59.453 59.453 0 00-6.034-6.934c-24.49-24.023-65.198-21.695-70.668-21.258H295.64c-5.519 0-9.994 4.475-9.994 9.994 0 5.518 4.474 9.994 9.994 9.994h35.721a128.53 128.53 0 00.241 8.206H10.157c-5.519 0-9.994 4.475-9.994 9.994 0 5.518 4.474 9.994 9.994 9.994h324.427c2.904 11.757 8.259 24.015 17.952 33.528v-.001c18.317 17.978 45.898 20.767 61.242 20.767 6.424 0 10.704-.489 11.261-.557a9.992 9.992 0 008.788-9.921c.424-5.725 1.147-24.832-5.345-43.816h73.36c5.519 0 9.994-4.475 9.994-9.994-.001-5.52-4.474-9.996-9.994-9.996zm-135.305 39.248s-.001 0 0 0c-8.274-8.12-12.149-19.739-13.886-30.321a10.149 10.149 0 00-.157-.997c-.942-6.174-1.174-11.942-1.144-16.379 11.878.24 33.419 2.638 46.818 15.781 13.457 13.208 15.786 35.013 15.968 46.945-12.092.069-34.187-1.864-47.599-15.029zM204.429 412.736H131.08c-5.519 0-9.994-4.475-9.994-9.994s4.474-9.994 9.994-9.994h73.349c5.519 0 9.994 4.475 9.994 9.994s-4.475 9.994-9.994 9.994zM86.608 412.736a10.063 10.063 0 01-7.065-2.929 10.064 10.064 0 01-2.928-7.064c0-2.628 1.069-5.207 2.928-7.065a10.068 10.068 0 017.065-2.928c2.628 0 5.207 1.068 7.065 2.928s2.928 4.437 2.928 7.065-1.069 5.207-2.928 7.064a10.065 10.065 0 01-7.065 2.929z"></path>
    </svg>
    )
}